import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { ShiftCMSState } from '@/store';
import AppUser from '@/components/AppUser.vue';
import AppMenu from '@/components/AppMenu.vue';
import AppNotifications from '@/components/AppNotifications.vue';
import AppDrawer from '@/components/AppDrawer.vue';
import { User } from '@/models/user.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShiftApp',
  setup(__props) {

const store = useStore<ShiftCMSState>();
const auth = computed<string>(() => store.state.token);
const user = computed<User | null>(() => store.state.loggedInUser);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (auth.value && user.value)
        ? (_openBlock(), _createBlock(AppMenu, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(AppUser),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(AppNotifications),
      _createVNode(AppDrawer)
    ]),
    _: 1
  }))
}
}

})